export const elasticSearchAuthDefaultFields = ['is_partner_only', 'download', 'category'];
